import { alertThresholdSeconds } from './alertThreshold'

export type DisplayStatus = 'online' | 'offline' | 'idle'

// Shape needed to derive the displayed status. The full AgentListItem satisfies this.
export interface LiveStatusAgent {
  isActive: boolean
  liveStatus: string
  checkType?: string | null
  lastKeepaliveAt?: string | null
  intervalSeconds?: number | null
  alertAfterMissed?: number | null
}

// #103 — the server's `liveStatus` is a point-in-time snapshot; a dashboard that
// polls only periodically (and not in background tabs) can show a stale "online"
// for an agent that has gone silent. So we re-derive overdue → offline on the
// client from `lastKeepaliveAt` (the same value the "last contact" label uses).
// This only ever DOWNGRADES online→offline; it never claims online. Cloud agents
// are region-aggregated server-side and are left to the server's verdict.
export function displayStatus(a: LiveStatusAgent, now: number = Date.now()): DisplayStatus {
  if (!a.isActive) return 'idle'

  const isCloud = (a.checkType ?? '').startsWith('cloud_')
  if (!isCloud && a.lastKeepaliveAt && a.intervalSeconds && a.alertAfterMissed) {
    const last = Date.parse(a.lastKeepaliveAt)
    if (!Number.isNaN(last)) {
      const thresholdMs = alertThresholdSeconds(a.intervalSeconds, a.alertAfterMissed, false) * 1000
      if (now - last > thresholdMs) return 'offline'
    }
  }

  if (a.liveStatus === 'online') return 'online'
  if (a.liveStatus === 'offline') return 'offline'
  return 'idle'
}
